import { useState } from 'react';
const Tooltip = ({
  children,
  tooltipContent,
}: {
  children: JSX.Element;
  tooltipContent: JSX.Element | string;
}) => {
  const [tooltipStatus, setTooltipStatus] = useState(0);
  return (
    <div className="flex-col md:flex-row flex items-center md:justify-center">
      <div
        className="relative"
        onMouseEnter={() => setTooltipStatus(1)}
        onMouseLeave={() => setTooltipStatus(0)}
      >
        <div className="me-2 cursor-pointer">{children}</div>
        {tooltipStatus === 1 && (
          <div
            role="tooltip"
            className={`z-20 -mt-20 w-64 absolute transition duration-150 ease-in-out ltr:left-0 rtl:right-00 ms-8 shadow-lg bg-gray-800 p-4 rounded`}
          >
            <svg
              className={`absolute ltr:left-0 rtl:right-0 -ms-2 bottom-0 top-0 h-full`}
              width="9px"
              height="16px"
              viewBox="0 0 9 16"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Page-1"
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
              >
                <g
                  id="Tooltips-"
                  transform="translate(-874.000000, -1029.000000)"
                  fill="#2D3748"
                >
                  <g
                    id="Group-3-Copy-16"
                    transform="translate(850.000000, 975.000000)"
                  >
                    <g id="Group-2" transform="translate(24.000000, 0.000000)">
                      <polygon
                        id="Triangle"
                        transform="translate(4.500000, 62.000000) rotate(-90.000000) translate(-4.500000, -62.000000) "
                        points="4.5 57.5 12.5 66.5 -3.5 66.5"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            {tooltipContent}
          </div>
        )}
      </div>
    </div>
  );
};
export default Tooltip;
